'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _Jwt = require('./Jwt');

var _Jwt2 = _interopRequireDefault(_Jwt);

var _Storage = require('./Storage');

var _Storage2 = _interopRequireDefault(_Storage);

var _RefreshToken = require('./RefreshToken');

var _RefreshToken2 = _interopRequireDefault(_RefreshToken);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utilities for working with stored access tokens
 * @namespace AccessToken
 * @example
 * import { AccessToken } from 'storis-jwt-auth';
 */
var AccessToken = function AccessToken() {
	(0, _classCallCheck3.default)(this, AccessToken);
};

AccessToken.exists = function () {
	return !!_Storage2.default.accessToken.get();
};

AccessToken.isExpired = function () {
	return AccessToken.exists() ? _Jwt2.default.isTokenExpired(_Storage2.default.accessToken.get()) : true;
};

AccessToken.isAcceptable = function () {
	return _Jwt2.default.isTokenAcceptable(_Storage2.default.accessToken.get());
};

AccessToken.willExpireBefore = function (seconds) {
	return AccessToken.exists() ? _Jwt2.default.willTokenExpireBefore(_Storage2.default.accessToken.get(), seconds) : true;
};

AccessToken.retrieve = function (url, _ref) {
	var scopes = _ref.scopes,
	    workspace = _ref.workspace,
	    other = (0, _objectWithoutProperties3.default)(_ref, ['scopes', 'workspace']);
	var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';
	var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { 'Content-Type': 'application/json' };
	return (
		/* eslint-disable indent */
		_RefreshToken2.default.isAcceptable() ? fetch(url, {
			method: method,
			headers: headers,
			body: (0, _stringify2.default)((0, _extends3.default)({
				refreshToken: _Storage2.default.refreshToken.get(),
				scopes: scopes,
				workspace: workspace
			}, other))
		}).then(function (response) {
			if (!response.ok) {
				throw new Error(response.statusText);
			}
			return response;
		}).then(function (response) {
			return response.json();
		}).then(function (_ref2) {
			var accessToken = _ref2.accessToken;

			if (!_Jwt2.default.isTokenWellFormed(accessToken)) {
				throw new Error('malformed access token received');
			}
			// store our new access token and hit the callback
			_Storage2.default.accessToken.set(accessToken);
		}) : _promise2.default.reject(new Error('a valid refresh token is required'))
	);
};

exports.default = AccessToken;